<template>
  <v-layout column>
    <v-flex class="pb-16">
      <text-field
        v-model.trim="form.firstName"
        :validator="vs.accountForm.firstName"
        :label="$t('firstName', 'First Name')"
        autofocus
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        v-model.trim="form.lastName"
        :validator="vs.accountForm.lastName"
        :label="$t('lastName', 'Last Name')"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        v-model.trim="form.email"
        :validator="vs.accountForm.email"
        :label="$t('email', 'Email')"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field v-model.trim="form.Address" :label="$t('address', 'Address')" />
    </v-flex>
    <v-flex class="pb-16">
      <text-field v-model.trim="form.City" :label="$t('cityOptional', 'City')" />
    </v-flex>
    <v-flex class="pb-16">
      <text-field v-model.trim="form.postalCode" :label="$t('postalCode', 'Postal code')" />
    </v-flex>
    <v-flex class="pb-16">
      <text-field v-model.trim="form.Country" :label="$t('countryOptional', 'Country')" />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'user-profile',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedLanguage: '',
      allLanguages: require('../../assets/languages.json'),
      form: {
        ...this.initialValues,
      },
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
  mounted() {
    Object.entries(this.allLanguages).find(([key, value]) => {
      if (key === this.initialValues.preferredLanguage) {
        this.selectedLanguage = value.name
      }
    })
  },
  methods: {
    selectLan(language) {
      let selectedLanguage
      Object.entries(this.allLanguages).find(([key, value]) => {
        if (value.name === language) {
          return (selectedLanguage = key)
        }
      })
      this.form.preferredLanguage = selectedLanguage
    },
    getLanguagesList() {
      const list = []
      Object.entries(this.allLanguages).forEach(([key, value]) => {
        list.push(value.name)
      })

      return list
    },
  },
}
</script>

<style scoped></style>
